import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import BankAccountAdd from '../../main/settings/bankAccount/bankAccountAdd';
import { addBarberBankAccount, uploadBankAccountDocuments } from '../../main/settings/actions';

class BarberUserAddBankAccountWrapper extends Component {

  saveBankAccount = (data) => {
    return this.props.saveBankAccount(this.props.barberUser.id, data);
  }

  uploadBankAccountDocuments = (documents) => {
    return uploadBankAccountDocuments(this.props.barberUser.id, 'barber', documents);
  }

  render() {
    return (
      <BankAccountAdd
        saveBankAccount={this.saveBankAccount}
        uploadBankAccountDocuments={this.uploadBankAccountDocuments}
        type="individual"
        redirectUrl="/barber/settings/bank-account"
      />
    );
  }
}

BarberUserAddBankAccountWrapper.propTypes = {
  saveBankAccount: PropTypes.func.isRequired,
  barberUser: PropTypes.object,
};

const mapStateToProps = state => ({
  barberUser: state.auth.barberUser,
});

const mapDispatchToProps = {
  saveBankAccount: addBarberBankAccount,
};

export default connect(mapStateToProps, mapDispatchToProps)(BarberUserAddBankAccountWrapper);
